import { Injectable, Inject } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Version } from '../models/version.model';

@Injectable({
  providedIn: 'root'
})
export class VersionService {
  headers: HttpHeaders = new HttpHeaders({ 'Content-Type': 'application/json' });
  baseUrl: string;
  constructor( 
    private httpClient: HttpClient,
    @Inject('BASE_URL') baseUrl: string) {
    this.baseUrl = baseUrl + 'assets/version/version.json';
  }

  getVersion() {
    const url = this.baseUrl;
    return this.httpClient.get<Version>(url);
  }
}
